@if (order) {
  <div class="order-item-list__toolbar">
    <button mat-stroked-button class="order-item-list__toolbar-btn" (click)="printAllLabels()">
      <mat-icon>print</mat-icon> Print all labels
    </button>
  </div>
}

@if (orderItems.length) {
  <div class="order-item-list__header">
    <h3 class="order-item-list__title">Added medicines</h3>
    <span class="order-item-list__count">{{ orderItems.length }} item(s)</span>
  </div>

  <div class="table-scroll">
    <div class="mbp-table-wrap">
      <table mat-table matSort [dataSource]="orderItems" class="mbp-data-table order-list">
        <ng-container matColumnDef="pack_size">
          <th mat-header-cell *matHeaderCellDef>Pack size</th>
          <td mat-cell *matCellDef="let item">{{ item.medicineDosagePackageType.contained_quantity }}</td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef>Qty</th>
          <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
          <td mat-cell *matCellDef="let item" class="name-col">{{ item.medicineDosagePackageType.label_name }}</td>
        </ng-container>
        <ng-container matColumnDef="dosage">
          <th mat-header-cell *matHeaderCellDef class="dosage-type-col">Dosage</th>
          <td mat-cell *matCellDef="let item" class="dosage-type-col">{{ item.dosageType.additional_information }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let item" class="status-cell">
            @if (readOnly) {
              <p class="status">{{ getStatus(item)?.status ?? '—' }}</p>
            }
            @if (!readOnly) {
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select
                  [value]="getStatus(item)"
                  [disabled]="isLoading"
                  (selectionChange)="changeOrderItemStatus($event, item)"
                  aria-label="Status">
                  @for (status of orderItemStatuses; track status) {
                    <mat-option [value]="status">{{ status.status }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Price</th>
          <td mat-cell *matCellDef="let item">
            <p class="price">R {{ getTotalPrice(item) }}</p>
          </td>
        </ng-container>
        <ng-container matColumnDef="remove">
          <th mat-header-cell *matHeaderCellDef class="remove-col">&nbsp;</th>
          <td mat-cell *matCellDef="let item" class="remove-col">
            <div class="row-actions">
              <button color="warn" (click)="deleteOrderItem(item)" mat-stroked-button class="order-item-list__row-btn order-item-list__row-btn--warn">
                <mat-icon>delete_outline</mat-icon> Remove
              </button>
              @if (order) {
                <button mat-stroked-button class="order-item-list__row-btn" (click)="printLabels([item])">
                  <mat-icon>print</mat-icon> Print
                </button>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
} @else {
  <div class="order-item-list__empty">
    <mat-icon>medication_liquid</mat-icon>
    <p>No medicines added yet</p>
    <span>Use the form above to search and add medicines to this prescription.</span>
  </div>
}
